var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{staticClass:"mb-3 d-block",attrs:{"href":"#"},on:{"click":_vm.open}},[_vm._v(_vm._s(_vm.link_text))])])}
var staticRenderFns = []

export { render, staticRenderFns }